export default __webpack_public_path__ + "static/media/success-tick.8b4db7c8.gif";